import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import { defaultI18nOptions } from "../../../i18n/config"

export const initializeI18n = () => {
  if (i18n.isInitialized) {
    return
  }

  i18n
    .use(
      new LanguageDetector(null, {
        lookupCookie: "lng",
        lookupLocalStorage: "lng",
      })
    )
    .use(initReactI18next)
    .init(defaultI18nOptions)
}

// Initialize i18n when this module is imported
initializeI18n()

// Component for React tree (returns null as it's only for side effects)
export const I18n = () => {
  return null
}

export { i18n }
